import * as Yup from "yup"
import { isValidPhoneNumber } from "libphonenumber-js"

const Schema = () => {
  return Yup.object().shape({
    givenName: Yup.string().required("Este campo es requerido"),
    familyName: Yup.string().required("Este campo es requerido"),
    email: Yup.string()
      .email("El email ingresado no es válido")
      .required("Este campo es requerido"),
    phone: Yup.string()
      .required("Este campo es requerido")
      .min(10, "El número de teléfono es muy corto")
      .test("phone", "El número de teléfono no es válido", value =>
        isValidPhoneNumber(`+${value}`)
      ),
    password: Yup.string()
      .required("Este campo es requerido")
      .min(
        8,
        "La contraseña es muy corta - mínimo, debería tener 8 caracteres"
      ),
    acceptPrivacyTerms: Yup.string().matches(
      /^true$/,
      "Debes aceptar las Políticas de Privacidad para crear tu cuenta"
    ),
    usCitizenDeclaration: Yup.string().matches(
      /^true$/,
      "No debes ser residente de Estados Unidos para crear tu cuenta"
    ),
  })
}

export default Schema
